export default __webpack_public_path__ + "static/media/cutting-stones.fb62c98c.md";